const colorStyles = [
  { bg: 'bg-yellow-50', text: 'text-yellow-600', border: 'border-yellow-100' },
  { bg: 'bg-green-50', text: 'text-green-500', border: 'border-green-100' },
  { bg: 'bg-red-50', text: 'text-red-500', border: 'border-red-100' },
]

function hashStringToIndex(str: string, max: number) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash)
  }
  return Math.abs(hash) % max
}

export function RankBadge(index: number, isStyled: boolean) {
  const idx = hashStringToIndex(String(index), colorStyles.length)
  const style = colorStyles[idx]

  return (
    <div
      className={
        isStyled
          ? `inline-block w-8 h-8 p-2 rounded-md text-text-m font-semibold border flex items-center justify-center ${style.bg} ${style.text} ${style.border}`
          : 'inline-block w-8 h-8 p-2 text-text-m flex items-center justify-center'
      }
    >
      {index + 1}
    </div>
  )
}
